module.exports = __webpack_public_path__ + "img/banner-pack.2692e95a.png";